import { render, staticRenderFns } from "./NeededItemQuickEditor.vue?vue&type=template&id=5bac1e4a&"
import script from "./NeededItemQuickEditor.vue?vue&type=script&lang=js&"
export * from "./NeededItemQuickEditor.vue?vue&type=script&lang=js&"
import style0 from "./NeededItemQuickEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports